import { render, staticRenderFns } from "./ReportMenu.vue?vue&type=template&id=53e52e08&"
import script from "./ReportMenu.vue?vue&type=script&lang=js&"
export * from "./ReportMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53e52e08')) {
      api.createRecord('53e52e08', component.options)
    } else {
      api.reload('53e52e08', component.options)
    }
    module.hot.accept("./ReportMenu.vue?vue&type=template&id=53e52e08&", function () {
      api.rerender('53e52e08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Dashboard/Layout/Extra/ReportMenu.vue"
export default component.exports